import React, {useCallback} from 'react';
import { ENV } from './config/env';
import logo from './assets/logo.svg';
import GooglePlay from './assets/GooglePlay.svg'
import AppStore from './assets/AppStore.svg'
import Rustore from './assets/RuStoreBlack.svg'
import './App.css';
import {ColorRing} from "react-loader-spinner";
import {googleLogout, useGoogleLogin} from "@react-oauth/google";
import axios from "axios";
import {useTranslation} from "react-i18next";
import i18n from "./utils/i18n";

// export const baseURL = 'https://api.auroracatch.com:15843/aurora/api/';
// export const baseURL = '/aurora/api/';
export const baseURL = ENV.API_BASE_URL;

const rustore_link = ENV.RUSTORE_LINK;

type UserData = {
    sub: string;
    name: string;
    given_name: string;
    family_name: string;
    picture: string;
    email: string;
    email_verified: boolean;
}

function App() {
const [deletePage, setDeletePage] = React.useState(false);
const [loading, setLoading] = React.useState(false);
const {t} = useTranslation(['app'])
const login = useGoogleLogin({
    flow: 'implicit',
    onSuccess: async (tokenResponse) => {
        try {
            const accessToken = tokenResponse.access_token;
            // const userData = (await axios.get(
            //     'https://www.googleapis.com/oauth2/v3/userinfo',
            //     {
            //         headers: {
            //             Authorization: `Bearer ${tokenResponse.access_token}`
            //         },
            //     }
            // )).data as UserData;

            const serverToken = (await axios.post(`${baseURL}auth/social/google`, {token: accessToken}))?.data?.data?.token;
            const result  = (await axios.delete(`${baseURL}user`, { headers: { Authorization: `Bearer ${serverToken}`,'Content-Type': 'application/json', } }))?.data;
            // console.log(JSON.stringify(result));

            alert(t('app:delete_success'));

        } catch (error) {
            console.error(error);
            alert(t('app:delete_fail'));
        } finally {
            setLoading(false);
            setDeletePage(false);
            setTimeout(() => {
                googleLogout();
            }, 2500)
        }
    },
    onError: () => {
        alert(t('app:delete_fail'));
        setLoading(false);
        setDeletePage(false);
    }
});

const onDelete = useCallback(() => {
    setLoading(true);
    login()
},[login])


  return (
    <div className="App">
      <div className={'App-container'}>
        <a className={'App-header'} href="/">
            <img src={logo} className="App-logo"/>
            <span className={'App-name'}>{t('app:title')}</span>
        </a>
        {!deletePage ?  (
            <>
                <span className={'App-subheader'}>{t('app:subheader')}</span>
                <div className={'App-feature-container'}>
                  <span className={'App-feature'}>{t('app:feature_1')}</span>
                  <span className={'App-feature'}>{t('app:feature_2')}</span>
                  <span className={'App-feature'}>{t('app:feature_3')}</span>
                  <span className={'App-feature'}>{t('app:feature_4')}</span>
                  <span className={'App-feature'}>{t('app:feature_5')}</span>
                </div>
                <div className={'App-store-buttons-container'}>
                    {/*<a className={'App-store-button'}><img src={GooglePlay}/></a>*/}
                    {/*<a className={'App-store-button'}><img src={AppStore}/></a>*/}
                    <a href={rustore_link} className={'App-store-button'}><img src={Rustore}/></a>
                </div>
                <a onClick={() => {setDeletePage(true)}} className={'App-delete-account-button'}>{t('app:delete_account_button')}</a>
            </>
        ) : (
            <>
                <span className={'App-subheader'}>{t('app:delete_account_title')}</span>
                <div className={'App-delete-page-buttons'}>
                    {!loading ? (
                        <>
                            <span className={'App-delete-account-button-no'} onClick={() => setDeletePage(false)}>{t('app:go_back')}</span>
                            <span className={'App-delete-account-button'} onClick={onDelete}>{t('app:yes')}</span>
                        </>
                    ) : (
                        <ColorRing
                            visible={true}
                            height="41"
                            width="41"
                            ariaLabel="color-ring-loading"
                            wrapperStyle={{}}
                            wrapperClass="color-ring-wrapper"
                            colors={['#E35757', '#E35757', '#E35757', '#E35757', '#E35757']}
                        />
                    )}
                </div>
            </>
        )}
      </div>
    </div>
  );
}

export default App;
